export default __webpack_public_path__ + "fonts/Gotham-Light.e3efa87f784f92c5e60e1fe991e3008a.woff";